import Joi from 'joi';
import _ from 'lodash';
import { pointSchema, validatePointColumnId, } from '../context-menu-events/util';
const MAX_CUSTOM_TOOLTIP_CSS_LENGTH = 100 * 1024;
const tooltipEventPayloadSchema = Joi.object({
    event: Joi.object({
        clientX: Joi.number().required(),
        clientY: Joi.number().required(),
    }).required(),
    point: pointSchema,
    customTooltipContent: Joi.array().items(Joi.string()),
    customTooltipCss: Joi.string()
        .allow('')
        .max(MAX_CUSTOM_TOOLTIP_CSS_LENGTH),
}).unknown(true);
export const validateShowToolTipEventPayloadObject = (object, columns) => {
    try {
        Joi.assert(object, tooltipEventPayloadSchema);
    }
    catch (err) {
        throw new Error(err.details[0].message);
    }
    if (!object.point) {
        return;
    }
    validatePointColumnId(object.point, columns);
};
export const convertPointValToNameValPair = (point, columns) => {
    const nameValPair = {};
    if (!point || !point.tuple) {
        return nameValPair;
    }
    point.tuple.forEach((pointVal) => {
        const colIdx = _.findIndex(columns, col => {
            return col.id === pointVal.columnId;
        });
        const col = columns[colIdx];
        nameValPair[col.name] = pointVal.value;
    });
    return nameValPair;
};
export const testHooks = {
    tooltipEventPayloadSchema,
};
//# sourceMappingURL=util.js.map